import React from 'react'

// import { Button, Loader, Modal } from '@/components'
import { Button, Loader } from '@/components'
import OralExamAudioPlayButton, {
  deriveMimeTypeFromUrl,
} from './OralExamAudioPlayButton'
import { formatTime } from './useAudioRecorder'

import './OralExam.scss'

const OralExamActivity = ({
  question,
  questionAudioSrc,
  timeRemaining,
  isSubmitted,
  isAutoSubmitting,
  isTimerExpired,
  isRecorderRecording,
  isTranscribing,
  isSubmitting,
  isRecorderSupported,
  recordingError,
  transcriptionError,
  transcribedText,
  // showTimeoutModal,
  onPause,
  onEnded,
  onRecord,
  onPlay,
}) => {
  const {
    content: questionContent,
    question: questionStem,
    textBeforeInput: questionText,
  } = question || {}
  return (
    <div className="oral-exam__wrapper">
      <p className="oral-exam__question-text">
        {questionStem || questionContent || questionText}
      </p>

      {questionAudioSrc && (
        <div className="oral-exam__audio-player">
          <OralExamAudioPlayButton
            audioType={deriveMimeTypeFromUrl(questionAudioSrc, 'audio/wav')}
            audioUrl={questionAudioSrc}
            autoplay
            isRecording={isRecorderRecording}
            onEnded={onEnded}
            onPause={onPause}
            onPlay={onPlay}
            questionId={questionAudioSrc}
          />
        </div>
      )}

      {!isSubmitted && !isAutoSubmitting && !isTimerExpired && (
        <div>
          <p className="oral-exam__timer">
            Time Remaining: {formatTime(timeRemaining)}
          </p>
          <p className="oral-exam__timer-note">
            Answer will be submitted automatically when time expires
          </p>
        </div>
      )}

      <div className="oral-exam__recording">
        {recordingError && (
          <p className="oral-exam__recording-error">{recordingError}</p>
        )}
        {!isRecorderSupported && (
          <p className="oral-exam__recording-error">
            Your browser does not support audio recording.
          </p>
        )}
        {transcriptionError && (
          <p className="oral-exam__recording-error">{transcriptionError}</p>
        )}

        {transcribedText && (
          <div className="oral-exam__transcription-result">
            <p className="oral-exam__transcription-result-title">
              Your answer:
            </p>
            <p className="oral-exam__transcribed-text">{transcribedText}</p>
          </div>
        )}

        {!isSubmitted && !isAutoSubmitting && (
          <>
            {isRecorderRecording && (
              <div className="oral-exam__is-loading">
                <Loader />
                <p>Recording audio...</p>
              </div>
            )}
            {isTranscribing && (
              <div className="oral-exam__is-loading">
                <Loader />
                <p>Transcribing audio...</p>
              </div>
            )}
            {isSubmitting && (
              <div className="oral-exam__is-loading">
                <Loader />
                <p>Submitting answer...</p>
              </div>
            )}
            {!isTranscribing && !isSubmitting && (
              <Button
                disabled={!isRecorderSupported}
                isInfo
                isRounded
                onClick={onRecord}
              >
                {isRecorderRecording
                  ? 'Stop Record'
                  : transcribedText
                  ? 'Re-record'
                  : 'Record'}
              </Button>
            )}
          </>
        )}

        {isAutoSubmitting && !transcribedText && (
          <div className="oral-exam__is-loading">
            <Loader />
            <p>Submitting answer...</p>
          </div>
        )}
      </div>

      {/*<div className="oral-exam__timeout-modal-wrapper">
        <Modal isOpen={showTimeoutModal}>
          <Modal.Header>Time&rsquo;s up</Modal.Header>
          <Modal.Body>
            <p>
              Time for this question has run out. Moving on to the next
              question.
            </p>
          </Modal.Body>
        </Modal>
      </div>*/}
    </div>
  )
}

export default OralExamActivity
